import { HcButton } from '@cosmos-web/hc-button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

import styles from './button.module.css'
import type { ButtonProps } from './types'

const Button = ({ children, icon, ...rest }: ButtonProps): JSX.Element => {
  return (
    <HcButton {...rest} className={clsx(rest.className, styles.btn)} role='button'>
      {icon ? (
        <div slot='icon' data-test='btn-icon'>
          <FontAwesomeIcon icon={icon} size='lg' />
        </div>
      ) : null}
      {children}
    </HcButton>
  )
}

export default Button
